import React from "react";

interface ISeeMoreButton {
  onClickHandler: (event: React.MouseEvent<HTMLElement>) => void;
}

const SeeMoreButton = ({ onClickHandler }: ISeeMoreButton): JSX.Element => {
  return (
    <button
      onClick={onClickHandler}
      className="flex w-fit border-b-2 border-dashed border-orange-20 text-p text-orange hover:border-orange"
    >
      <div className="flex items-center">See More</div>
    </button>
  );
};

export default SeeMoreButton;
